import { TrashAlt } from "@vapor/react-icons";
import { Box, Stack, Typography, useTheme } from "@vapor/react-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDeleteTaxSubmission } from "../../../../../../core/api/use-delete-tax-submission/useDeleteTaxSubmission";
import type { TaxSubmissionDetailDTO } from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { TaxSubmissionDeleteModal } from "../../tax-submission-delete-modal/TaxSubmissionDeleteModal";
import type { SecondaryOption } from "../TaxSubmissionDetailToolbar";

export const useGetCtaDeleteTaxSubmission = (
    onTaxSubmissionUpdate: () => unknown,
    taxSubmissionDetail: TaxSubmissionDetailDTO,
): SecondaryOption => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [taxSubmissionDeleteModalOpen, setTaxSubmissionDeleteModalOpen] =
        useState(false);

    const {
        isPending: loadingTaxSubmissionDelete,
        mutateAsync: deleteTaxSubmission,
    } = useDeleteTaxSubmission();

    const onClickDeleteTaxSubmission = async () => {
        await deleteTaxSubmission({
            taxSubmissionId: taxSubmissionDetail.id,
        });
        onTaxSubmissionUpdate();
    };

    return {
        element: (
            <>
                <Stack
                    direction="row"
                    onClick={() => setTaxSubmissionDeleteModalOpen(true)}
                >
                    <TrashAlt color="interactive" />
                    <Box sx={{ mr: 1 }}></Box>
                    <Typography
                        color={theme.palette.primary.interactiveDefault}
                    >
                        {t(
                            "views.home.components.tax_submission_detail_toolbar.secondary_cta.delete_tax_submission",
                        )}
                    </Typography>
                </Stack>
                <TaxSubmissionDeleteModal
                    loading={loadingTaxSubmissionDelete}
                    onDelete={onClickDeleteTaxSubmission}
                    open={taxSubmissionDeleteModalOpen}
                    onClose={() => setTaxSubmissionDeleteModalOpen(false)}
                />
            </>
        ),
    };
};
